import { Gallery } from "src/libs/useful"
import { IPlayListProps, PlayListContainer } from "./PlayList"
import { InlineButton } from "."
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */ 
const PlayListCarousel = ({items, ...props}: IPlayListProps ): JSX.Element => {
    const cards = items.map((item, i) => {
        return <InlineButton
            key={i}
            src={item?.src}
            label={item.label || __("Empty playlist")}
            description={item.content }
            image={item?.image || props.image?.toString() || ""}
            padding={ props.padding }
            intent={ props.intent }
            minimal={ props.minimal } 
            btnWidth={ props.btnWidth || 640 }
            btnHeight={ props.btnHeight || 360 }
            fill={ props.fill }
            isModal={ false } 
            isAutoMode={ false }
            isPlayButton={ typeof props.isPlayButton === "undefined" ? true : props.isPlayButton  && !!items.length }
            isPlayed={ false } 
        />
    })
    const onSwitch = ( i: number) => {  
        props.onSwitch( i )
    }
    return <PlayListContainer {...props} items={items} containerWidth={props.btnWidth || 640} current={props.current} > 
        <Gallery 
            items={ cards } 
            itemWidth={ props.btnWidth || 640 }               
            itemHeight={ props.btnHeight || 360 } 
            navigation
            navigationPositionType={ props.navigationPositionType }
            navigationSizeType={props.navigationSizeType}
            navigationThemeType={props.navigationThemeType}
            navigationDesignType={props.navigationDesignType}
            count={1}
            loop
            type="element"
            padding={ 10 }
            on={onSwitch} 
        /> 
        <></>
    </PlayListContainer>
}
export default PlayListCarousel